import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PurchaseOrderDetail from "../purchase-orders/detail";
import PurchaseOrdersOverview from "../purchase-orders/purchase-orders";
import ProductDrafts from "./product-drafts";
import Suppliers from "./suppliers";

const PARENT_URL = "/cms/orders";

const PurchaseOrders = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<PurchaseOrdersOverview />} />
      <Route path={`all/:id`} element={<PurchaseOrderDetail />} />
      <Route path={`/product-drafts`} element={<ProductDrafts />} />
      <Route path={`/suppliers`} element={<Suppliers />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default PurchaseOrders;
